module.exports = __webpack_public_path__ + "media/images/bsmart/icons/random-ec66c1d96ccbc2e87030b4f432ae2e68.svg";